// extracted by mini-css-extract-plugin
module.exports = {"exercise":"_2DUPrrIBw0GYbXeDrJj222"};